export const LOADER_TRAININGS          = 'LOADER_TRAININGS';
export const GET_TRAININGS             = 'GET_TRAININGS';
export const TRAININGS_FAIL            = 'TRAININGS_FAIL';
export const SAVE_LOADER_TRAININGS     = 'SAVE_LOADER_TRAININGS';
export const FORM_TRAININGS_FAIL       = 'FORM_TRAININGS_FAIL';

